import { mapProjectRates } from '~/modules/rateCard/advancedRateCard/components/hooks/utils';
import { CostOverrideType } from '../CostOverrideType';

export const mapCostOverrideRates = (projectRates, projectDimensions) =>
  mapProjectRates(projectRates, projectDimensions).map(rate => {
    const hasNonZeroAmount = rate.amount?.amount > 0;
    const hasPercentMarkup =
      rate.percentMarkup !== null && rate.percentMarkup !== undefined;

    const isPercentMarkup = !hasNonZeroAmount && hasPercentMarkup;

    return {
      ...rate,
      type: isPercentMarkup
        ? CostOverrideType.PERCENT_MARKUP
        : CostOverrideType.HOURLY_RATE,
      percent: isPercentMarkup ? rate.percentMarkup : 0
    };
  });

export default mapCostOverrideRates;
